import * as Preact from 'preact';

/**
 * Our Root component isn't used as a regular page in the application, as it renders before the app is initialised (see useParentAPI for initialisation)
 *
 * Therefore, when this is displayed we don't have access to our feature flags, client API, or any other state that is set up by initialisation.
 */
export const Component = () => <></>;
